module.exports = "/static/fonts/OpenSans-Italic.ttf";